import { Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import { FC } from 'react';
import styles from './RefreshDate.module.scss';

interface RefreshDateProps {
  variant: 'small' | 'medium';
  refreshDate?: Date;
}

const defaultProps = { refreshDate: undefined };

const formatDate = (refreshDate: Date): string => {
  const formatter = new Intl.DateTimeFormat('es-es', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
  return formatter.format(refreshDate);
};

const RefreshDate: FC<RefreshDateProps> = ({ refreshDate, variant }) => (
  <span>
    {refreshDate ? (
      <Typography variant={variant === 'small' ? 'caption' : 'body2'} color="text.secondary">
        <span className={styles.refreshDate__content}>
          {formatDate(refreshDate)}
          <Tooltip title="Refresh date">
            <span className={styles.refreshDate__content__icon}>
              <Icon iconId="refreshDate" />
            </span>
          </Tooltip>
        </span>
      </Typography>
    ) : undefined}
  </span>
);

RefreshDate.defaultProps = defaultProps;

export default RefreshDate;
